import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { useRecoilValue } from "recoil";

import { Spacer } from "../../base";
import StepsList from "./StepsList";

const getStepComponent = (step: number, stepDefinitions: any[]) =>
  stepDefinitions.find((def) => def.number === step)?.Component ?? null;

const stepContentVariants = {
  visible: { x: 0, opacity: 1 },
  muted: { x: 0, opacity: 0.5 },
  first: { opacity: 0 },
  hidden: { opacity: 0, y: 10 },
  exit: { opacity: 0, y: -10 },
};

const ModalSteps = ({ stepDefinitions, stepSelector }) => {
  // @ts-expect-error -- Monorepo migration
  const { step, loading } = useRecoilValue(stepSelector);

  const StepContent = getStepComponent(step, stepDefinitions);

  return (
    <>
      <Spacer size={36} />
      <StepsList current={step} loading={loading} steps={stepDefinitions} />
      <Spacer size={46} />
      <motion.div layout>
        <AnimatePresence mode="wait">
          {/* {loading ? (
            <motion.div
              key="loading"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={stepContentVariants}
            >
              <FlexLoadingBlock size={120} />
            </motion.div>
          ) : ( */}
          <motion.div
            key={`step-${step}`}
            animate={loading ? "muted" : "visible"}
            exit="exit"
            initial={step > 1 ? "hidden" : "first"}
            variants={stepContentVariants}
          >
            <StepContent loading={loading} />
          </motion.div>
          {/* )} */}
        </AnimatePresence>
      </motion.div>
    </>
  );
};

export default ModalSteps;
